
const m = window.require("embercom/serializers/base/embercom-base-serializer");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
